import React from 'react';
import PropTypes from 'prop-types';
import { FIELD_TYPES } from 'utils/constants';
import RadioGroupContainer from '../../RadioGroupContainer';
import RadioButtonAttribute from '../RadioButtonAttribute';

class TypesContainer extends React.Component {
  onTypeChange = (keyPath, field) => {
    this.props.onFieldValueChange([...keyPath, 'editorType'], field);
  }

  render() {
    const { type } = this.props.values;

    const textFieldButtonOrNull = !this.props.isDropdownOrRadio ?
      (
        <RadioButtonAttribute
          disabled={this.props.disabled}
          field={FIELD_TYPES.TEXT}
          keyPath={this.props.keyPath}
          label="Text"
          onRadioButtonChange={this.onTypeChange}
          radioGroupName={this.props.radioGroupName}
          value={type === FIELD_TYPES.TEXT}
        />
      ) : null;

    return (
      <RadioGroupContainer
        disabled={this.props.disabled}
        radioGroupName={this.props.radioGroupName}
        uiState={this.props.uiState}
      >
        {
          textFieldButtonOrNull
        }
        <RadioButtonAttribute
          disabled={this.props.disabled || !this.props.isDropdownOrRadio || type === FIELD_TYPES.RADIO_BUTTON || type === FIELD_TYPES.MULTIPICKLIST}
          field={FIELD_TYPES.DROPDOWN}
          keyPath={this.props.keyPath}
          label="Dropdown"
          onRadioButtonChange={this.onTypeChange}
          radioGroupName={this.props.radioGroupName}
          value={this.props.values.editors.editorType === FIELD_TYPES.DROPDOWN}
        />
        <RadioButtonAttribute
          disabled={this.props.disabled || !this.props.isDropdownOrRadio}
          field={FIELD_TYPES.RADIO_BUTTON}
          keyPath={this.props.keyPath}
          label="Radio Buttons"
          onRadioButtonChange={this.onTypeChange}
          radioGroupName={this.props.radioGroupName}
          value={this.props.values.editors.editorType === FIELD_TYPES.RADIO_BUTTON || type === FIELD_TYPES.RADIO_BUTTON}
        />
      </RadioGroupContainer>
    );
  }
}

TypesContainer.propTypes = {
  disabled: PropTypes.bool,
  radioGroupName: PropTypes.string.isRequired,
  keyPath: PropTypes.array.isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  uiState: PropTypes.object,
  isDropdownOrRadio: PropTypes.bool,
};

TypesContainer.defaultProps = {
  disabled: false,
  isDropdownOrRadio: false,
  uiState: {},

};

export default TypesContainer;
